module.exports = "https://img.xiyuyouxi.com/saas/img/Payment_icon1.bf5e9618.png";